import { render, staticRenderFns } from "./SettingsButton.vue?vue&type=template&id=3a7a85ea&scoped=true"
import script from "./SettingsButton.vue?vue&type=script&lang=ts"
export * from "./SettingsButton.vue?vue&type=script&lang=ts"
import style0 from "./SettingsButton.vue?vue&type=style&index=0&id=3a7a85ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7a85ea",
  null
  
)

export default component.exports